import DOMPurify from "dompurify";
import React, { Fragment, useEffect, useState } from "react";
import "./ServerInfo.scss";
import "../User/VUser.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getApiUserRoles,
  getClusterData,
  getLiveJobList,
  getServerStats,
} from "../../Utils/actions";
import { Card } from "react-bootstrap";
import { abbrNum } from "../../Utils/utils";
import { useTranslation } from "react-i18next";
import ChartDisplay from "../Dashboard/ChartDisplay";
import WorkIcon from "@mui/icons-material/Work"; // activeJobs
import DoneAllIcon from "@mui/icons-material/DoneAll"; // completedJobs
import InputIcon from "@mui/icons-material/Input"; // totalRecordsIn
import OutputIcon from "@mui/icons-material/Output"; // totalRecordsOut
import MemoryIcon from "@mui/icons-material/Memory"; // noCores
import StorageIcon from "@mui/icons-material/Storage"; // heapUsage

const ServerInfo = () => {
  const {
    serverStats,
    clusterData,
    liveJobList,
    finishList,
    clusterDataTemplate,
  } = useSelector((state) => state.data);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  // const serverStats = "<b> Application Configuration Parameters </b></br>Application Home : /home/ashish/WorkDirectory/veras-clone/bluecardinal-veras<br/>Log File Configuration :  null<br/><br/><b>JAVA Configuration Parameters </b><br/>Java Runtime Environment :  OpenJDK Runtime Environment<br/>Java Home :  /snap/eclipse/73/plugins/org.eclipse.justj.openjdk.hotspot.jre.full.linux.x86_64_17.0.8.v20230831-1047/jre<br/>Java Version :  17.0.8.1<br/>Java Compiler :  HotSpot 64-Bit Tiered Compilers<br/>Java VM Vendor :  Eclipse Adoptium<br/>Java VM Name :  OpenJDK 64-Bit Server VM<br/>Java Temp Directory :  /tmp<br/>Application Server :  jetty/9.4.35.v20201120<br/><br/><b> Resource Utilization </b><br/><br/><b> Server Uptime </b><br/>DateTime: 2024/01/22 10:32:50<br/>UpTime: 58:47:15 HH:MM:SS<br/><br/><b> Thread Utilization </b><br/>Peak thread count : 78<br/>Live thread count : 77<br/>Deamon thread count : 14<br/><br/><b> Heap Memory Utilization </b><br/> Headp Sort Art and Menu items will return s pleto check<br/>Peak thread count : 78<br/>Live thread count : 77<br/>Deamon thread count : 14<br/><br/><b> Heap Memory Utilization </b><br/> Headp Sort Art and Menu items will return s pleto check"

  useEffect(() => {
    if (isFirstRender) {
      dispatch(getServerStats());
      dispatch(getClusterData());
      // dispatch(getLiveJobList('active', { pageNumber: 1, pageSize: 100 }));
      // dispatch(getLiveJobList('not', { pageNumber: 1, pageSize: 100 }));
      setIsFirstRender(false);
    } else {
      setTimeout(() => {
        dispatch(getClusterData());
        dispatch(getServerStats());
      }, 30000);
    }
  }, [serverStats]); // Empty dependency array means this effect runs once after the initial render

  useEffect(() => {
    dispatch(getApiUserRoles(sessionStorage.getItem("username")));
  }, []);

  return (
    <>
      <div
        className="col-md-12 server-health-main-content"
        style={{
          backgroundColor: "#333333",
          height: "89vh",
          padding: "15px",
          // paddingTop: "21px",
          width: "100%",
          // overflow: "auto"
        }}
      >
        <Card
          className={"col-md-12 p-0 m-0 w-100 server-health-card"}
          style={{
            boxShadow: "none",
            border: "none",
            display: "flex",
            backgroundColor: "#333333",
          }}
        >
          <Card.Body
            className="blue_card"
            style={{ paddingTop: "5px", height: "8vh", paddingBottom: "5px" }}
          >
            <div className="row" style={{ margin: "0px" }}>
              <div className="col-md-2 col-sm-4 card-box">
                <div
                  className="bgDescColor p-2"
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#242424",
                    paddingTop: "10px !important",
                  }}
                >
                  <Card.Title
                    style={{
                      fontSize: "15px",
                      paddingTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      justifyContent:"center"

                    }}
                  >
                    <WorkIcon fontSize="small" />
                    {t("activeJobs")} :{" "}
                  </Card.Title>
                  <span style={{ fontSize: "15px" }}>
                      {clusterDataTemplate.activeTemplate || "-"}
                    </span>
                </div>
              </div>
              <div className="col-md-2 col-sm-4 card-box">
                <div
                  className="bgDescColor p-2"
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#242424",
                    paddingTop: "10px !important",
                  }}
                >
                  <Card.Title
                    style={{
                      fontSize: "15px",
                      paddingTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      justifyContent:"center"
                    }}
                  >
                    <DoneAllIcon fontSize="small" />
                    {t("completedJobs")} :
                    
                  </Card.Title>
                  <span style={{ fontSize: "15px" }}>
                      {clusterDataTemplate.finishedTemplate
                        ? clusterDataTemplate.finishedTemplate
                        : "-"}
                    </span>
                </div>
              </div>
              <div className="col-md-2 col-sm-4 card-box">
                <div
                  className="bgDescColor p-2"
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#242424",
                    paddingTop: "10px !important",
                  }}
                >
                  <Card.Title
                    style={{
                      fontSize: "15px",
                      paddingTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      justifyContent:"center"
                    }}
                  >
                    <InputIcon fontSize="small" />
                    {t("totalRecordsIn")} :{" "}
                   
                  </Card.Title>
                   <span style={{ fontSize: "15px" }}>
                      {clusterDataTemplate.totalRecordsIn
                        ? clusterDataTemplate.totalRecordsIn
                        : "-"}
                    </span>
                </div>
              </div>
              <div className="col-md-2 col-sm-4 card-box">
                <div
                  className="bgDescColor p-2"
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#242424",
                    paddingTop: "10px !important",
                  }}
                >
                  <Card.Title
                    style={{
                      fontSize: "15px",
                      paddingTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      justifyContent:"center"
                    }}
                  >
                    <OutputIcon fontSize="small" />
                    {t("totalRecordsOut")} :{" "}
                   
                  </Card.Title>
                   <span style={{ fontSize: "15px" }}>
                      {clusterDataTemplate.totalRecordsOut
                        ? clusterDataTemplate.totalRecordsOut
                        : "-"}
                    </span>
                </div>
              </div>
              <div className="col-md-2 col-sm-4 card-box">
                <div
                  className="bgDescColor p-2"
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#242424",
                    paddingTop: "10px !important",
                  }}
                >
                  <Card.Title
                    style={{
                      fontSize: "15px",
                      paddingTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      justifyContent:"center"
                    }}
                  >
                    <MemoryIcon fontSize="small" />
                    {t("noCores")} :
                    
                  </Card.Title>
                  <span style={{ fontSize: "15px" }}>
                      {abbrNum(
                        clusterData?.processorCount
                          ? clusterData?.processorCount
                          : "-"
                      )}
                    </span>
                </div>
              </div>
              <div className="col-md-2 col-sm-4 card-box">
                <div
                  className="bgDescColor p-2"
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#242424",
                    paddingTop: "10px !important",
                  }}
                >
                  <Card.Title
                    style={{
                      fontSize: "15px",
                      paddingTop: "5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      justifyContent:"center"
                    }}
                  >
                    <StorageIcon fontSize="small" />
                    {t("heapUsage")} :{" "}
                   
                  </Card.Title>
                   <span style={{ fontSize: "15px" }}>
                      {clusterData?.heapUsage
                        ? `${Math.ceil(clusterData.heapUsage * 100) / 100}/${
                            Math.ceil(clusterData.heapTotal * 100) / 100
                          }`
                        : "0/0"}
                    </span>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
        <Card
          className="shadow-none border-0 graph_content1 server-health-content"
          style={{
            backgroundColor: "#333333",
            borderRadius: "5px",
            color: "#c7c7c7",
            marginTop: "10px",
          }}
        >
          <Card.Body
            className="col-md-12 d-flex flex-column flex-md-row gap-3 server_content"
            style={{
              height: "77vh",
              gap: "15px",
              paddingRight: "0px",
              paddingLeft: "0px",
            }}
          >
            {/* Left: Chart + Node Info */}
            <div
              className="col-md-6 flex-fill"
              style={{
                backgroundColor: "#2b2b2b",
                borderRadius: "6px",
                padding: "25px",
                paddingTop: "0px",
              }}
            >
              <ChartDisplay />
              {clusterDataTemplate.clusterMode && (
                <div style={{ marginTop: "20px" }}>
                  <b>Node Info</b>
                  <p>
                    Name: {clusterDataTemplate.currentNode}, Load Average:{" "}
                    {clusterDataTemplate.currentLoadAvg}
                  </p>

                  <b>Connected Node</b>
                  {Object.entries(clusterDataTemplate.connectedNode).map(
                    ([key, value]) => (
                      <p style={{ marginBottom: "0px" }} key={key}>
                        Access url: {key}, Load Average: {value}
                      </p>
                    )
                  )}
                </div>
              )}
            </div>

            {/* Right: Server Stats */}
            <div
              className="col-md-6 flex-fill"
              style={{
                backgroundColor: "#2b2b2b",
                borderRadius: "6px",
                padding: "25px",
                overflow: "auto",
              }}
            >
              <p
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(serverStats),
                }}
              />
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default ServerInfo;
